import React from 'react';

import {GamesSliderWidgetGameViewModel} from "../../../../../widgets/games-slider-widget/models/games-slider-widget.game-view-model";
import {BaseProps} from "../../../../../infrastructure/models/props/base-props";
import classNames from 'classnames';
import styles from '../../style/slider.module.scss';

export class SliderWidgetCardStatusProps extends BaseProps {
  game: GamesSliderWidgetGameViewModel;
}

export const SliderWidgetCardStatus = ({game}: SliderWidgetCardStatusProps) => {
  const {isLive, gameTimeDisplay, statusText} = game;
  const containerProps = {
    className: classNames(styles.slider_widget_card_status, {[styles.slider_widget_card_status_live]: isLive})
  };

  return (
    <div {...containerProps}>
      {
        isLive ? gameTimeDisplay : statusText
      }
    </div>
  )
};
